import { Expose } from "class-transformer";
import isNil from "lodash/isNil";
import type { RealEstateCurrentAddressTypeEnum } from "../../constants/real-estate/real-estate-current-address-type.enum";
import { RealEstateTenureTypeEnum } from "../../constants/real-estate/real-estate-tenure-type.enum";

const OWNED_PROPERTY_TYPES: RealEstateTenureTypeEnum[] = [
  RealEstateTenureTypeEnum.PROPRIETA,
  RealEstateTenureTypeEnum.NUDA_PROPRIETA,
];

export class RealEstateRelationship {
  @Expose()
  realEstateTenureType?: RealEstateTenureTypeEnum;

  @Expose()
  realEstateTenureTypeOther?: string;

  @Expose()
  realEstateTenureShare?: number;

  @Expose()
  realEstateMortgage?: boolean;

  @Expose()
  realEstateResidualMortgage?: number;

  @Expose()
  realEstateRentContractRegistered?: boolean;

  @Expose()
  realEstateRentContractYear?: number;

  @Expose()
  realEstateRentMonthlyRent?: number;

  @Expose()
  realEstateMainHome?: boolean;

  @Expose()
  currentAddressType?: RealEstateCurrentAddressTypeEnum;

  @Expose()
  livesInCareFacility?: boolean;

  public isOwnedProperty(): boolean {
    return !isNil(this.realEstateTenureType) && OWNED_PROPERTY_TYPES.includes(this.realEstateTenureType);
  }

  public isRentedProperty(): boolean {
    return !isNil(this.realEstateTenureType) && this.realEstateTenureType === RealEstateTenureTypeEnum.LOCAZIONE;
  }
}
